import { createAction } from '@reduxjs/toolkit';

import type { ColorShuffleInfo } from 'js/src/data/color-shuffle/color-shuffle-types';
import { COLOR_SHUFFLE_ACTIONS } from 'js/src/data/color-shuffle/color-shuffle-types';

export const setColorShuffleDataForSlide = createAction<{
    sceneId: string;
    colorShuffleInfo: ColorShuffleInfo;
    systemTriggered: boolean;
    parentActionGroup: string | undefined;
}>(COLOR_SHUFFLE_ACTIONS.SET_SLIDE_COLOR_SHUFFLE_DATA);

export const setColorShuffleIndexForSlide = createAction<{
    sceneId: string;
    colorShuffleIndex: number;
    systemTriggered: boolean;
    parentActionGroup: string | undefined;
}>(COLOR_SHUFFLE_ACTIONS.SET_SLIDE_COLOR_SHUFFLE_INDEX);

export const setTemplateColorShufflePalettes = createAction<{
    palettes: number[][];
    systemTriggered: boolean;
    parentActionGroup: string | undefined;
}>(COLOR_SHUFFLE_ACTIONS.SET_TEMPLATE_COLOR_SHUFFLE_PALETTES);

export const setTemplateColorShuffleIndex = createAction<{
    colorShuffleIndex: number;
    systemTriggered: boolean;
    parentActionGroup: string | undefined;
}>(COLOR_SHUFFLE_ACTIONS.SET_TEMPLATE_COLOR_SHUFFLE_INDEX);
